<template>
  <div class="px-1">
    <checkout-list-product v-for="product in cartProducts" :key="product.id" :cart-product="product"/>
  </div>
</template>

<script>
import CheckoutListProduct from "./CheckoutListProduct";

export default {
  name: "CheckoutListProducts",
  components: {
    CheckoutListProduct
  },
  data() {
    return {}
  },
  computed: {
    cartProducts() {
      return this.$store.state.Shop.cartItems;
    },
  },
  methods: {

  }
}
</script>

<style scoped>

</style>
